import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import ActiveGalileoCard from './partials/ActiveGalileoCard';
import { USA_CARD_GET_IMAGE } from './queries';
import { showAlert } from '../../utilities/notifications';
import { useCardStatus } from '../../utilities/sharedHooks/user';
import { CARD_NETWORKS } from './constants';

const CardGalileoBackSideView = () => {
  const { t: translate } = useTranslation();

  const { data: cardStatus } = useCardStatus({ enabled: true });

  const { data, refetch } = useQuery(USA_CARD_GET_IMAGE, {
    onError(error) {
      showAlert({ message: error.message, type: 'danger' });
    },
  });

  return (
    <ModalBodyLayout
      withBack={false}
      renderHeader={() => (
        <div className="flex-row-center w-100">
          <b className="text-f5 text-dark">{translate('card_galileo_details_title')}</b>
        </div>
      )}>
      <ActiveGalileoCard url={data?.url} onError={refetch} />
      <div className="w-100">
        <div className="alert alert-info" role="alert">
          <i className="icon icon-info-icon" />
          <span className="content mx-md-4">
            {cardStatus?.network?.toUpperCase() === CARD_NETWORKS.MASTERCARD
              ? translate('card_galileo_details_mastercard_note')
              : translate('card_galileo_details_visa_note')}
          </span>
        </div>
      </div>
    </ModalBodyLayout>
  );
};

export default CardGalileoBackSideView;

CardGalileoBackSideView.propTypes = {};
